<p-chart 
type="line" 
[data]="data" 
[options]="options" 
[height]="'100%'"
[width]="'100%'"></p-chart>
